

import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import './css/base.css'
import './css/common.css'
import './css/components.css'
import './js/rem.js'
import axios from 'axios'


import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Scroller from 'vux/src/components/scroller/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import AlertModule from 'vux/src/plugins/alert/module'
import XInput from 'vux/src/components/x-input/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Badge from 'vux/src/components/badge/index.vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import Rater from 'vux/src/components/rater/index.vue'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Countup from 'vux/src/components/countup/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

import vuei18n from 'vue-i18n'

Vue.config.productionTip = false

Vue.component('tabbar', Tabbar)
Vue.component('tabbar-item', TabbarItem)
Vue.component('swiper', Swiper)
Vue.component('x-header', XHeader)
Vue.component('cell-box', CellBox)
Vue.component('cell', Cell)
Vue.component('group', Group)
Vue.component('scroller', Scroller)
Vue.component('toast', Toast)
Vue.component('actionsheet', Actionsheet)
Vue.component('x-switch', XSwitch)
Vue.component('x-button', XButton)
Vue.component('alert', Alert)
Vue.component('x-input', XInput)
Vue.component('x-table', XTable)
Vue.component('grid', Grid)
Vue.component('grid-item', GridItem)
Vue.component('tab', Tab)
Vue.component('tab-item', TabItem)
Vue.component('badge', Badge)
Vue.component('x-dialog', XDialog)
Vue.component('popup-picker', PopupPicker)
Vue.component('x-textarea', XTextarea)
Vue.component('loading', Loading)
Vue.component('confirm', Confirm)
Vue.component('rater', Rater)
Vue.component('inline-x-switch', InlineXSwitch)
Vue.component('x-number', XNumber)
Vue.component('popup', Popup)
Vue.component('countup', Countup)
Vue.component('flexbox', Flexbox)
Vue.component('flexbox-item', FlexboxItem)
Vue.component('load-more', LoadMore)
Vue.use(AlertPlugin)
Vue.use(AjaxPlugin)
Vue.use(vuei18n)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)



Vue.prototype.$http.defaults.baseURL = 'https://api.abeiyun.com/'
Vue.prototype.$http.defaults.withCredentials = true
Vue.prototype.$http.interceptors.request.use(config => {
config.headers = {
'Content-Type': 'application/x-www-form-urlencoded'
}
return config
} , error => Promise.reject(error))


/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js